import { Card, Form } from "react-bootstrap";
import CustomButton from "../../components/CustomButton/CustomButton";
import { useEffect, useState } from "react";
import WebService from "../../utility/WebService";
import { EyeFill, PencilFill, TrashFill } from "react-bootstrap-icons";
import DeleteModal from "../../components/DeleteModal/DeleteModal";
import CustomTableSortable from "../../components/CustomTable/CustomTableSortable";
import HelperService from "../../utility/HelperService";
import AddAdminUser from "./AddOrganization";
import { toast } from "react-toastify";
import ViewOrganization from "./ViewOrganization";

export interface OrganizationInterface {
    _id: number
    name: string;
    email?: string | null;
    phone?: string | null;
    website?: string | null;
    category?: string | null;
    gstNumber?: string | null;
    logo?: string | null;
    country: string | number | null;
    state: string | number | null;
    city: string | number | null;
    pinCode: string | null;
    address?: string | null;
    status: OrganizationStatus;
    type: OrganizationType;
}

export enum OrganizationStatus {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
    DELETED = 'DELETED'
}

export enum OrganizationType {
    ORGANIZATION = 'ORGANIZATION',
    PERSONAL = 'PERSONAL'
}

const columns = [

    {
        id: "name",
        label: "Organization Name",
        minWidth: 170,
        sortable: true,
    },
    {
        id: "email",
        label: "Office Email",
        minWidth: 170,
        sortable: false,
    },
    {
        id: "primaryContact",
        label: "Primary Contact",
        minWidth: 170,
        sortable: true,
    },
    {
        id: "website",
        label: "Website",
        minWidth: 170,
        sortable: false,
    },
    {
        id: "category",
        label: "Category",
        minWidth: 170,
        sortable: true,
    },
    {
        id: "membershipStatus",
        label: "Membership Status",
        minWidth: 170,
        sortable: true,
    },
    {
        id: "createdAt",
        label: "Created Date",
        minWidth: 170,
        sortable: true,
    },
    {
        id: "action",
        label: "Action",
        minWidth: 100,
        align: "center" as const,
    },
];


const Organization = () => {
    const [showAdminBlade, setShowAdminBlade] = useState(false);
    const [leadershipCouncils, setLeadershipCouncils] = useState([]);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [leadershipCouncilToDelete, setLeadershipCouncilToDelete] = useState<string | null>(null);
    const [totalCount, setTotalCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    const [search, setSearch] = useState("");
    const [sortField, setSortField] = useState<string>("createdAt");
    const [sortOrder, setSortOrder] = useState<"asc" | "desc">("desc");
    const [uiSortField, setUiSortField] = useState<string>("createdAtFormatted");
    const [loading, setLoading] = useState<boolean>(false);
    const sortFieldMap: Record<string, string> = {
        name: "name",
        primaryContact: "contactName",
        category: "category.name",
        membershipStatus: "subscriptionStatus",
        createdAt: "createdAt",
    };
    const [userObject, setUserObject] = useState<OrganizationInterface | null>(null)
    const [showOrganizationView, setShowOrganizationView] = useState(false);
    const [pagePermission, setPagePermission] = useState({
        canView: false,
        canAdd: false,
        canEdit: false,
        canDelete: false,
    });
    useEffect(() => {
        // getOrganizationList(search, currentPage);
        getOrganizationList(search, currentPage);
    },  [currentPage, search, sortField, sortOrder]);
    const getOrganizationList = (keyword: string = "", page = currentPage) => {
        setLoading(true);
        const params = new URLSearchParams();
        // params.append("page", currentPage.toString());
        params.append("page", page.toString());
        params.append("limit", itemsPerPage.toString());

        // Keyword search
        if (keyword.trim()) {
            params.append("keyword", keyword.trim());
        }

        // Sorting
        params.append("sortField", sortField);
        params.append("sortOrder", sortOrder);

        WebService.getAPI({
            action: `organizations/get-pagination-list?${params.toString()}`,
        })
            .then((res: any) => {
                const perm = res?.data?.permissions || {};

                setPagePermission({
                    canView: perm.canView,
                    canAdd: perm.canAdd,
                    canEdit: perm.canEdit,
                    canDelete: perm.canDelete,
                });
                const formattedRows = res?.data?.data.map((item: any) => {
                    return {
                        ...item,
                        fullName: item.fullName || "-",
                        email: item.email || "-",
                        website: item.website || "-",
                        // primaryContact: item?.subscription?.contactNumber || "-",
                        primaryContact: item?.subscription?.contactName || "-",
                        membershipStatus: item?.subscription?.status || "-",
                        category: item.category?.name || "-",
                        createdAt: HelperService.getFormatedDate(item.createdAt),
                        action: actionList(item, perm),


                    };
                });
                setLeadershipCouncils(formattedRows);
                setTotalCount(res?.data?.pagination?.total);
            })
            .catch((err: any) => {
                console.error("Error fetching admin users:", err);
            })
            .finally(() => {
                setLoading(false);
            });
    };


    const handleDeleteEvent = (leadershipCouncilId: string) => {
        setLeadershipCouncilToDelete(leadershipCouncilId);
        setShowDeleteModal(true);
    };

    const actionList = (item: any, perm: any) =>
    (
        <div>
            {perm.canEdit && (
                <PencilFill className="me-3 cursor-pointer" size={16}
                    onClick={() => {
                        setShowAdminBlade(true);
                        setUserObject(item);
                    }}
                    title="Edit"
                />)}
            {perm.canDelete && (
                <EyeFill className="me-3 cursor-pointer" size={18}
                    onClick={() => {
                        setShowOrganizationView(true);
                        setUserObject(item);
                    }}
                    title="View"
                />)}
            {perm.canDelete && (
                <TrashFill
                    className="cursor-pointer"
                    size={16}
                    color="#DC143C"
                    onClick={() => handleDeleteEvent(item._id)}
                    title="Delete"
                />
            )}
        </div>
    );
    return (
        <>
            <AddAdminUser
                show={showAdminBlade}
                handleClose={() => {
                    setShowAdminBlade(false);
                    getOrganizationList(search, currentPage);
                    setUserObject(null);
                }}
                data={userObject}
            />
            <ViewOrganization
                show={showOrganizationView}
                handleClose={() => {
                    setShowOrganizationView(false);
                    getOrganizationList(search, currentPage);
                    setUserObject(null);
                }}
                data={userObject}
            />
            <DeleteModal
                show={showDeleteModal}
                onHide={() => setShowDeleteModal(false)}
                onDelete={() => {
                    if (leadershipCouncilToDelete) {
                        WebService.deleteAPI({
                            action: `organizations/delete-organization/${leadershipCouncilToDelete}`,
                        }).then(() => {
                            setShowDeleteModal(false);
                            toast.success("Organization deleted successfully.");
                            getOrganizationList(search, currentPage);
                        })
                            .catch(() => {
                                toast.error("Failed to delete organization.");
                            });
                    }
                }}
                message="Are you sure you want to delete this organization? All associated users will be automatically converted to Individual users. This action cannot be undone."

            />
            <div className="events-main">
                <Card className="event-card">
                    <div className="d-flex justify-content-between">
                        <div className="page-title">Organization</div>
                        {pagePermission.canAdd && (
                        <CustomButton
                            isLoading={false}
                            label="Add"
                            onClick={() => {
                                setShowAdminBlade(true);
                                setUserObject(null);
                            }}
                            style={{ width: 80 }}
                        />
                        )}
                    </div>
                    <div className="row">
                        <div className="col-md-3">
                            <Form.Label className="label">Search</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Enter name or email or contact"
                                value={search}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    setSearch(value);
                                    setCurrentPage(1);
                                    // getOrganizationList(value, 1); // ✅ FIX
                                }}
                            />
                        </div>
                    </div>
                    <CustomTableSortable
                        columns={columns}
                        rows={leadershipCouncils}
                        totalCount={totalCount}
                        currentPage={currentPage}
                        pageSize={itemsPerPage}
                        onPageChange={(page) => {
                            setCurrentPage(page);
                        }}
                        isLoading={loading}
                        sortField={uiSortField}
                        sortOrder={sortOrder}
                        onSortChange={(columnId, order) => {
                            setUiSortField(columnId);
                            setSortOrder(order);
                            const apiField = sortFieldMap[columnId] || "createdAt";
                            setSortField(apiField);
                            setCurrentPage(1);
                            // getOrganizationList(search, 1); // ✅ FIX
                        }}
                    />
                </Card>
            </div>
        </>
    );
};

export default Organization;
